import { type Flag, useFeatureFlagWithPrefs } from '@fs/zion-flags'

export type NewMergeFlag = Flag<undefined> & { treatment: 'on' | 'thirdColumn' }

export default function useNewMergeFlag(): ReturnType<typeof useFeatureFlagWithPrefs<NewMergeFlag>> {
  return useFeatureFlagWithPrefs<NewMergeFlag>('treeWeb_personR9_newMerge', {}, { userPreferences: ['fslabs.labs'] })
}
